import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import { isBoolean } from "lodash";
import { useState } from "react";
import { Confirm, useNotify } from "react-admin";
import {
  TenantRegistrationApiFactory,
  TenantRegistrationDto,
} from "../../../common/data/service-proxies";
import { useAxiosInstance } from "../../../common/hooks/useAxiosInstance";
import LockOpen from "@material-ui/icons/LockOpen";
import { Lock } from "@material-ui/icons";

interface Props {
  record?: TenantRegistrationDto;
  resource?: string;
  onClick?: (event: React.MouseEvent) => void;
  onSuccess?: () => void;
  hidden?: boolean | ((record: TenantRegistrationDto) => boolean);
}

export const SuspendOrReactivateMasterAccessMenuItem = ({
  record,
  hidden,
  onClick,
  onSuccess,
  ...rest
}: Props) => {
  const [isConfirmOpen, setConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const axios = useAxiosInstance();
  const notify = useNotify();

  if (!record?.id) {
    return null;
  }

  if (isBoolean(hidden)) {
    if (hidden) {
      return null;
    }
  } else {
    if (hidden && hidden(record)) {
      return null;
    }
  }

  const handleDialogClose = () => {
    setConfirmOpen(false);
  };

  const handleSuspendOrReactivate = () => {
    if (!axios) {
      return;
    }

    const action = record.masterAccessSuspended
      ? TenantRegistrationApiFactory(undefined, axios.defaults.baseURL, axios)
          .apiAppTenantregistrationIdReactivatemasteraccountPost
      : TenantRegistrationApiFactory(undefined, axios.defaults.baseURL, axios)
          .apiAppTenantregistrationIdSuspendmasteraccountPost;

    const actionDescription = record.masterAccessSuspended
      ? "Reactivate"
      : "Suspend";
    setLoading(true);
    action(record.id!)
      .then(() => {
        notify(
          `resources.master-tenant-registrations.notifications.master${actionDescription}Success`,
          {
            type: "success",
          }
        );

        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((e) => console.error(e))
      .finally(() => {
        setLoading(false);
        setConfirmOpen(false);
      });
  };

  const label = record.masterAccessSuspended
    ? "Reactivate master access"
    : "Suspend master access";
  return (
    <>
      <MenuItem
        {...rest}
        className="actions-menu-item"
        onClick={(e) => {
          setConfirmOpen(true);
          if (typeof onClick === "function") {
            onClick(e);
          }
        }}
      >
        <ListItemIcon>
          {record.masterAccessSuspended ? <LockOpen /> : <Lock />}
        </ListItemIcon>
        <ListItemText>{label}</ListItemText>
      </MenuItem>
      <Confirm
        isOpen={isConfirmOpen}
        loading={loading}
        title={`Confirm to ${label}`}
        content={`Are you sure you want to ${label} for '${record.name}'?`}
        onConfirm={handleSuspendOrReactivate}
        onClose={handleDialogClose}
      />
    </>
  );
};
